<template>
  <div class="open-source-cmp" @click="hiddenLanguageOptions">
    <switch-i18n ref="i18nRef" />
    <div class="article-wrapper">
      <h1>{{ appName }}{{ $t('common.openSourceTitle') }}</h1>
      <slot name="app-desc"></slot>
      <table>
        <tr>
          <th>{{ $t('common.openSourceTable01') }}</th>
          <th>{{ $t('common.openSourceTable02') }}</th>
          <th>{{ $t('common.openSourceTable03') }}</th>
        </tr>
        <template v-for="item in datas" :key="item.title">
          <tr>
            <td><a :href="item.titleLink" target="_blank">{{ item.title }}</a></td>
            <td><a :href="item.licenseLink" target="_blank">{{ item.license }}</a></td>
            <td>{{ item.hasChanged ? $t('common.openSourceTable04') : $t('common.openSourceTable05') }}</td>
          </tr>
        </template>
      </table>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import { useTitle } from '@/hooks/useTitle'
import { useHideLanguageOptions } from '@/hooks/useHideLanguageOptions';
import SwitchI18n from "@/components/switch_i18n.vue"

// 定义属性
defineProps({
  appName: {
    type: String,
    default: '',
  },
  datas: {
    type: Array,
    default: () => [],
  },
});

// 监听到语言发生改变后修改标题
useTitle('common.openSourceTitle');

// 点击空白区域隐藏语言选择框
const { i18nRef, hiddenLanguageOptions } = useHideLanguageOptions();
</script>

<style lang="less">
td:last-child {
  text-align: center;
}
</style>
